export const API_CONFIG = {
    HOST: process.env.REACT_APP_API_GATEWAY_HOST,
    PLUGO_REPORTS_API_HOST: process.env.REACT_APP_PLUGO_REPORTS_API_HOST
  };